

  <div class="top">
    <h2>Announcements</h2>
    <button *ngIf="hasPermissions('create_announcement')" nz-button nzType="primary" nzShape="circle" (click)="showAddModal()">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
    </button>
  </div>

  <nz-list style="padding-left: 20px; padding-right: 20px;" [nzDataSource]="announcements" [nzRenderItem]="item" [nzItemLayout]="'horizontal'" [nzLoading]="loading">
    <ng-template #item let-item>
      <nz-comment [nzAuthor]="item.createdby" [nzDatetime]="item.created_date | date">
        <nz-comment-content>
          <p>{{ item.text }}</p>
        </nz-comment-content>
        <nz-comment-action *ngIf="hasPermissions('create_announcement')">
          <span 
            style="cursor: pointer;" 
            nz-tooltip 
            nzTitle="Delete" 
            (click)="delete(item)"
          >
            <span nz-icon nzType="delete"></span>
          </span>
        </nz-comment-action>
      </nz-comment>
    </ng-template>
  </nz-list>
    



<nz-modal [(nzVisible)]="announcementModal" nzTitle="Add Announcement" (nzOnCancel)="announcementModal = false;" (nzOnOk)="addAnnoucement()">
  <ng-container *nzModalContent>
    <form [formGroup]="announcementForm">
      <nz-form-item>
        <nz-form-label nzRequired>Company(s)</nz-form-label>
        <nz-select nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="Select a company(s)" formControlName="company" style="width: 100%">
          <nz-option *ngFor="let comp of companies" [nzLabel]="comp.name" [nzValue]="comp.id"></nz-option>
        </nz-select>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzRequired>Announcement</nz-form-label>
        <input nz-input placeholder="Input the announcement" formControlName="note"/>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>